import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReceiptModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { ReceiptAction } from '../actions';
import { ReceiptReducer } from '../reducers';
import { ReceiptSelector } from '../selectors';

@Injectable()
export class ReceiptFacade {
  selectedItem$ = this._store.select(ReceiptSelector.selectReceipt);
  constructor(private _store: Store<ReceiptReducer.ReceiptState>) {}

  /**
   * Get @ReceiptModel by id
   */
  getById(id: number): Observable<ReceiptModel | null> {
    this._store.dispatch(ReceiptAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<ReceiptModel | null>;
  }
}
